import { Form, type FormItemProps, Input as AntdInput, type InputProps as AntdInputProps, Select } from 'antd';

import type { Ii18nLabel } from '@/types/common';
import { getFormItemLabel } from './utils';

interface InputProps extends FormItemProps, AntdInputProps, Ii18nLabel {
  name: string;
  children: any;
  onReset: any;
  options?: any;
}

const { Option } = Select;

export const InputWithDropdown = ({ name, label, i18nLabel, rules, min, max, options, disabled }: InputProps) => {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item name={name} label={fieldLabel} rules={rules}>
      <AntdInput
        disabled={disabled}
        min={min}
        max={max}
        addonAfter={
          <Form.Item name={`${name}Currency`} noStyle={true}>
            <Select style={{ width: '80px', textAlign: 'center' }} defaultValue={1}>
              {options.map((item: any) => (
                <Option style={{ textAlign: 'center' }} key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        }
      />
    </Form.Item>
  );
};
